import { useRef } from 'react';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu';
import { cx } from './cx';

export function SegmentedControl({ label, options, value, onChange, className }) {
  return (
    <div className={cx('segmented', className)} role="group" aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className="segmented__item"
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export function Tabs({ label, tabs, value, onChange, className }) {
  const listRef = useRef(null);

  const onKeyDown = (event) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault();
    const index = tabs.findIndex((tab) => tab.id === value);
    const step = event.key === 'ArrowRight' ? 1 : -1;
    const next = tabs[(index + step + tabs.length) % tabs.length];
    onChange(next.id);
    listRef.current?.querySelector(`[data-tab-id="${next.id}"]`)?.focus();
  };

  return (
    <div ref={listRef} className={cx('tabs', className)} role="tablist" aria-label={label} onKeyDown={onKeyDown}>
      {tabs.map(({ id, label: tabLabel, icon: Icon, count }) => (
        <button
          key={id}
          type="button"
          role="tab"
          className="tab"
          data-tab-id={id}
          aria-selected={id === value}
          tabIndex={id === value ? 0 : -1}
          onClick={() => onChange(id)}
        >
          {Icon && <Icon aria-hidden="true" />}
          {tabLabel}
          {count !== undefined && <span className="tab__count">{count}</span>}
        </button>
      ))}
    </div>
  );
}

export function Chip({ pressed, count, children, className, ...rest }) {
  return (
    <button type="button" className={cx('chip', className)} aria-pressed={pressed} {...rest}>
      {children}
      {count !== undefined && <span className="chip__count">{count}</span>}
    </button>
  );
}

export function Pagination({ page, pages, onChange, summary, previousLabel, nextLabel, disabled }) {
  if (pages <= 1) return null;
  return (
    <nav className="pagination" aria-label={summary}>
      <span>{summary}</span>
      <span className="pagination__controls">
        <button type="button" className="btn btn--sm" disabled={disabled || page <= 1} onClick={() => onChange(page - 1)}>
          <LuChevronLeft className="btn__icon" aria-hidden="true" />
          {previousLabel}
        </button>
        <button type="button" className="btn btn--sm" disabled={disabled || page >= pages} onClick={() => onChange(page + 1)}>
          {nextLabel}
          <LuChevronRight className="btn__icon" aria-hidden="true" />
        </button>
      </span>
    </nav>
  );
}
